export enum NachrichtSuccessType{
    SAVED = 'gespeichert',
    SENT = 'gesendet'
}
